<template>
    <div class="participationRate" :id="Id"></div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['InjectData', 'Id'],
    data() {
        return {
            chartInstance: null
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        InjectData: {
            handler() {
                // this.participation_graphics()
                this.Proportion();
            },
            deep: true,
        }
    },

    // 方法集合
    methods: {
        Proportion(data) {
            let that = this;
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }
            this.chartInstance = this.$echarts.init(document.getElementById(this.Id));
            this.chartInstance.setOption({
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 100,
                    }
                ],
                legend: {
                    show: true,
                    bottom: '3%',           // 距离容器底部 3%
                    left: 'center',
                    formatter: function (name) {
                        // 示例：根据 name 添加后缀
                        const suffixMap = {
                            'good_ratio': '优良率',
                            'qualified_ratio': '合格率',
                            'need_improvement_ratio': '待提升',
                        };
                        return (suffixMap[name] || '');
                    },      // 水平居中
                },
                grid: {
                    top: '10%',
                    left: '1%',
                    right: '4%',
                    bottom: '15%',
                    containLabel: true
                },
                dataset: {
                    dimensions: ['name', 'good_ratio', 'qualified_ratio', 'need_improvement_ratio'],
                    source: that.InjectData
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        formatter: function (value) {
                            return value.includes('前测卷') ? '测评卷一' :
                                value.includes('后测卷') ? '测评卷二' :
                                    value;
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            return value + '%'; // 将值加上百分比符号
                        }
                    }
                },
                series: [
                    {
                        name: 'good_ratio',
                        type: 'bar',
                        encode: { y: 'good_ratio' },
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => params.value[params.seriesName] + '%'
                        }
                    },
                    {
                        name: 'qualified_ratio',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: 'qualified_ratio' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => params.value[params.seriesName] + '%'
                        }
                    },
                    {
                        name: 'need_improvement_ratio',
                        type: 'bar',
                        barWidth: 30,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: 'need_improvement_ratio' },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                            formatter: (params) => params.value[params.seriesName] + '%'
                        }
                    },
                ]
            })
            window.addEventListener("resize", () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            });
        },
    },
    mounted() {
        if (this.InjectData) {
            this.Proportion();
        }
    },
    updated() {
        // 确保在DOM更新后重新绘制图表
        this.$nextTick(() => {
            if (this.InjectData) {
                this.Proportion();
            }
        });
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }

        // 移除resize事件监听器
        window.removeEventListener("resize", () => {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        });
    }
}
</script>
<style scoped lang="less">
.participationRate {
    width: 100%;
    height: 100%;
}
</style>